import { Button } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { Line } from 'app/components/pages/GiftCards/details/Line/Line';
import type { Voucher as VoucherType } from 'app/typings/voucher';
import { VoucherReasonType } from 'app/typings/voucher';
import { dayjs } from 'app/utils/dayjs';

type Props = {
  setIsVoucherModalVisible: (bool: boolean) => void;
  voucher?: VoucherType;
};

export const Voucher = ({ setIsVoucherModalVisible, voucher }: Props) => {
  const { currencyFormatter } = useContext(CurrencyContext);

  if (!voucher) {
    return null;
  }

  const {
    code,
    initialValue,
    remainingValue,
    expirationDate,
    reasonType,
    comment,
    createdAt,
    createdBy,
  } = voucher;

  return (
    <div className="bloc">
      <div className="title-with-button2">
        <div className="label">Voucher</div>
        <div>
          <Button
            className="button"
            onClick={() => setIsVoucherModalVisible(true)}
          >
            Edit
          </Button>
        </div>
      </div>
      <div className="generic-content">
        <Line title="Code" value={code} />
        <Line title="Initial value" value={currencyFormatter(initialValue)} />
        <Line
          title="Remaining value"
          value={currencyFormatter(remainingValue)}
        />
        <Line
          title="Expiry date"
          value={dayjs(expirationDate).format('DD/MM/YYYY')}
        />
        <Line
          title="Created at"
          value={dayjs(createdAt).format('DD/MM/YYYY')}
        />
        <Line title="Created by" value={createdBy} />
        {/** @ts-ignore -- legacy directive, needs investigation */}
        <Line title="Reason type" value={VoucherReasonType[reasonType]} />
        {!!comment && <Line title="Comment" value={comment} />}
      </div>
    </div>
  );
};
